import { create } from "zustand";

/**
 * Ephemeral, non-navigational workspace UI state.
 *
 * `expandedVisitUuids` tracks which patient-flow cards have their stage/subtask
 * tracker open. This is independent of patient selection: a card's chevron
 * toggles its tracker, and several can be open at once - so this is a set, not
 * a single id.
 */
interface WorkspaceState {
  expandedVisitUuids: Set<string>;
  toggleExpanded: (uuid: string) => void;
}

export const useWorkspaceStore = create<WorkspaceState>((set) => ({
  expandedVisitUuids: new Set(),
  toggleExpanded: (uuid) =>
    set((state) => {
      const next = new Set(state.expandedVisitUuids);
      if (next.has(uuid)) next.delete(uuid);
      else next.add(uuid);
      return { expandedVisitUuids: next };
    }),
}));
